var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_851_6768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9991 17.6618C12.5401 17.6618 12.9787 17.2232 12.9787 16.6822C12.9787 16.1412 12.5401 15.7026 11.9991 15.7026C11.4581 15.7026 11.0195 16.1412 11.0195 16.6822C11.0195 17.2232 11.4581 17.6618 11.9991 17.6618Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9991 5.14307C11.4603 5.14307 11.0195 5.58388 11.0195 6.12266V13.4696C11.0195 14.0084 11.4603 14.4492 11.9991 14.4492C12.5379 14.4492 12.9787 14.0084 12.9787 13.4696V6.12266C12.9787 5.58388 12.5379 5.14307 11.9991 5.14307Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1962 10.0506L13.9391 0.803258C12.8615 -0.264497 11.1179 -0.264497 10.0501 0.803258L0.802769 10.0506C-0.264986 11.1282 -0.264986 12.8718 0.802769 13.9494L10.0501 23.1967C10.5889 23.7355 11.2942 24 11.9995 24C12.7048 24 13.4101 23.7355 13.9489 23.1967L23.1962 13.9494C24.2738 12.8718 24.2738 11.1282 23.1962 10.0506ZM21.815 12.5584L12.5677 21.8057C12.2542 22.1094 11.7546 22.1192 11.4411 21.8057L2.19379 12.5584C1.88032 12.2449 1.88032 11.7453 2.19379 11.4318L11.4411 2.19428C11.7448 1.88081 12.2542 1.88081 12.5677 2.19428L21.815 11.4416C22.1285 11.7551 22.1285 12.2547 21.815 12.5682V12.5584Z",
    fill: "#121212"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_851_6768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.fb5cf8ed9183635ac9edf7603c0cfdee.svg";
export { ForwardRef as ReactComponent };